import { memo } from 'react';

import { Menu } from '@headlessui/react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Icon } from '@shared/ui';
import { saveFile } from '@widgets/Files/helpers/saveFile';
import { IFIleEntity } from '@widgets/Files/model/types/fileEntity.interface';

import { useDropdown } from './useDropdown';
import cls from '../FileCard.module.css';

interface IDropdownProps {
    fileInfo: IFIleEntity;
}
export const Dropdown = memo(({ fileInfo }: IDropdownProps) => {
    const { t } = useTranslation();
    const { onChangeModalMode, onChangeCurrentFile } = useDropdown();
    return (
        <Menu>
            <Menu.Button
                onClick={(event) => {
                    event.stopPropagation();
                    onChangeCurrentFile(fileInfo.id, fileInfo);
                }}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                }}
                className={cls.menu}
            >
                <Icon iconName="filesDropdownDots" />
            </Menu.Button>
            <Menu.Items className={cls.menuItems}>
                <Menu.Item className={cls.item}>
                    <span
                        onClick={async (event) => {
                            event.stopPropagation();
                            await saveFile(fileInfo.originalUrl, fileInfo.name);
                        }}
                    >
                        <Icon iconName="filesDownload" />
                        {t('Dropdown.return.item.save')}
                    </span>
                </Menu.Item>
                <Menu.Item className={cls.item}>
                    <span
                        onClick={(event) => {
                            event.stopPropagation();
                            onChangeModalMode('edit');
                        }}
                    >
                        <Icon iconName="filesEdit" />
                        {t('Dropdown.return.item.rename')}
                    </span>
                </Menu.Item>
                <Menu.Item className={classNames(cls.item, cls.delete)}>
                    <span
                        onClick={(event) => {
                            event.stopPropagation();
                            onChangeModalMode('delete');
                        }}
                    >
                        <Icon iconName="filesDelete" />
                        {t('Dropdown.return.item.delete')}
                    </span>
                </Menu.Item>
            </Menu.Items>
        </Menu>
    );
});
